function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-2",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-3",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434"
}, /*#__PURE__*/React.createElement("path", {
  id: "_8",
  "data-name": 8,
  className: "cls-1",
  d: "M35.356,65H29.644a3.809,3.809,0,0,1-.952-7.5v-1.58a.765.765,0,0,0-.624-.744A22.877,22.877,0,0,1,19.6,51.673a.769.769,0,0,0-.973.082L17.5,52.883A3.8,3.8,0,0,1,11.539,57.5L7.5,53.461a3.81,3.81,0,0,1,4.629-5.975l1.117-1.117a.769.769,0,0,0,.082-.973,22.878,22.878,0,0,1-3.505-8.463.765.765,0,0,0-.744-.624H7.5a3.814,3.814,0,0,1-3.827,2.854A3.826,3.826,0,0,1,0,35.3V29.644a3.809,3.809,0,0,1,3.938-3.806,3.857,3.857,0,0,1,3.542,2.854h1.6a.765.765,0,0,0,.744-.624A22.877,22.877,0,0,1,13.327,19.6a.769.769,0,0,0-.082-.973l-1.117-1.117A3.81,3.81,0,0,1,7.5,11.539l4.04-4.04a3.81,3.81,0,0,1,5.975,4.629l1.117,1.117a.769.769,0,0,0,.973.082,22.879,22.879,0,0,1,8.464-3.505.765.765,0,0,0,.624-.744V7.5A3.809,3.809,0,0,1,29.644,0h5.713a3.809,3.809,0,0,1,.952,7.5v1.58a.765.765,0,0,0,.624.744A22.877,22.877,0,0,1,45.4,13.327a.769.769,0,0,0,.973-.082l1.118-1.118A3.809,3.809,0,0,1,53.461,7.5l4.04,4.04a3.81,3.81,0,0,1-4.629,5.975l-1.117,1.117a.769.769,0,0,0-.082.973,22.878,22.878,0,0,1,3.505,8.463.765.765,0,0,0,.744.624h1.594a3.845,3.845,0,0,1,3.332-2.841h0A3.809,3.809,0,0,1,65,29.644v5.713a3.8,3.8,0,0,1-7.483.952H55.923a.765.765,0,0,0-.744.624A22.877,22.877,0,0,1,51.673,45.4a.769.769,0,0,0,.082.973l1.117,1.117A3.809,3.809,0,0,1,57.5,53.461l-4.04,4.04A3.8,3.8,0,0,1,47.5,52.883L46.37,51.756a.769.769,0,0,0-.973-.082,22.879,22.879,0,0,1-8.464,3.505.765.765,0,0,0-.624.744V57.5a3.809,3.809,0,0,1-.952,7.5ZM19.165,49a3.319,3.319,0,0,1,1.858.568,20.351,20.351,0,0,0,7.529,3.119,3.308,3.308,0,0,1,2.679,3.237v2.412a1.589,1.589,0,0,1-1.587,1.587,1.27,1.27,0,0,0,0,2.539h5.713a1.27,1.27,0,0,0,0-2.539,1.589,1.589,0,0,1-1.587-1.587V55.923a3.308,3.308,0,0,1,2.679-3.237,20.355,20.355,0,0,0,7.529-3.119,3.313,3.313,0,0,1,4.187.393l1.746,1.746a1.531,1.531,0,0,1,0,2.163,1.307,1.307,0,0,0-.121,1.748,1.27,1.27,0,0,0,1.876.088l4.04-4.04a1.269,1.269,0,0,0-1.8-1.8l-.041.041a1.531,1.531,0,0,1-2.163,0L49.96,48.165a3.313,3.313,0,0,1-.393-4.187,20.352,20.352,0,0,0,3.119-7.529,3.308,3.308,0,0,1,3.237-2.679h2.469a1.531,1.531,0,0,1,1.53,1.53,1.307,1.307,0,0,0,1.15,1.322,1.27,1.27,0,0,0,1.388-1.264V29.644a1.27,1.27,0,0,0-1.388-1.264,1.307,1.307,0,0,0-1.15,1.322,1.531,1.531,0,0,1-1.53,1.53H55.923a3.308,3.308,0,0,1-3.237-2.679,20.355,20.355,0,0,0-3.119-7.529,3.313,3.313,0,0,1,.393-4.187l1.706-1.706a1.589,1.589,0,0,1,2.244,0,1.27,1.27,0,1,0,1.8-1.8l-4.04-4.04a1.27,1.27,0,0,0-1.8,1.8,1.589,1.589,0,0,1,0,2.244L48.165,15.04a3.313,3.313,0,0,1-4.187.393,20.351,20.351,0,0,0-7.529-3.119A3.308,3.308,0,0,1,33.77,9.077V6.665a1.589,1.589,0,0,1,1.587-1.587,1.27,1.27,0,1,0,0-2.539H29.644a1.27,1.27,0,0,0,0,2.539A1.589,1.589,0,0,1,31.23,6.665V9.077a3.308,3.308,0,0,1-2.679,3.237,20.355,20.355,0,0,0-7.529,3.119,3.313,3.313,0,0,1-4.187-.393L15.13,13.334a1.587,1.587,0,0,1,0-2.245,1.27,1.27,0,0,0-1.8-1.8l-4.04,4.04a1.27,1.27,0,0,0,1.8,1.8,1.589,1.589,0,0,1,2.244,0l1.706,1.706a3.313,3.313,0,0,1,.393,4.187,20.352,20.352,0,0,0-3.119,7.529A3.308,3.308,0,0,1,9.077,31.23H6.6a1.522,1.522,0,0,1-1.52-1.52,1.315,1.315,0,0,0-1.225-1.335,1.27,1.27,0,0,0-1.314,1.269V35.3a1.312,1.312,0,0,0,1.222,1.33,1.27,1.27,0,0,0,1.317-1.269A1.589,1.589,0,0,1,6.665,33.77H9.077a3.308,3.308,0,0,1,3.237,2.679,20.355,20.355,0,0,0,3.119,7.529,3.313,3.313,0,0,1-.393,4.187l-1.746,1.746a1.531,1.531,0,0,1-2.163,0l-.041-.041a1.269,1.269,0,0,0-1.8,1.8l4.04,4.04a1.27,1.27,0,0,0,1.876-.088,1.307,1.307,0,0,0-.121-1.748,1.531,1.531,0,0,1,0-2.163l1.746-1.746a3.288,3.288,0,0,1,2.33-.96Z",
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-4",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(22.254 16.481)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_7",
  "data-name": 7,
  className: "cls-1",
  d: "M180.719,140.567a5.345,5.345,0,1,1,5.345-5.345A5.351,5.351,0,0,1,180.719,140.567Zm0-8.144a2.8,2.8,0,1,0,2.8,2.8A2.8,2.8,0,0,0,180.719,132.423Z",
  transform: "translate(-175.374 -129.878)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-5",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(19.374 35.931)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_6",
  "data-name": 6,
  className: "cls-1",
  d: "M157.29,292.385a4.623,4.623,0,1,1,4.623-4.623A4.629,4.629,0,0,1,157.29,292.385Zm0-6.7a2.078,2.078,0,1,0,2.078,2.079A2.081,2.081,0,0,0,157.29,285.683Z",
  transform: "translate(-152.667 -283.138)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-6",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(33.545 28.245)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_5",
  "data-name": 5,
  className: "cls-1",
  d: "M272.24,238.33a7.855,7.855,0,0,1-7.805-6.94,1.273,1.273,0,1,1,2.528-.295,5.314,5.314,0,1,0,5.869-5.906,1.272,1.272,0,1,1,.279-2.53,7.859,7.859,0,0,1-.87,15.67Z",
  transform: "translate(-264.425 -222.653)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-7",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(38.463 20.549)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_4",
  "data-name": 4,
  className: "cls-1",
  d: "M304.273,164.425a1.273,1.273,0,1,1,.9-.373A1.282,1.282,0,0,1,304.273,164.425Z",
  transform: "translate(-303 -161.88)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-8",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(31.227 46.333)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_3",
  "data-name": 3,
  className: "cls-1",
  d: "M247.273,367.545a1.273,1.273,0,1,1,.9-.373A1.282,1.282,0,0,1,247.273,367.545Z",
  transform: "translate(-246 -365)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-9",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(16.968 31.244)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_2",
  "data-name": 2,
  className: "cls-1",
  d: "M134.943,248.675a1.273,1.273,0,1,1,.9-.373A1.28,1.28,0,0,1,134.943,248.675Z",
  transform: "translate(-133.67 -246.13)"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u041A\\u043E\\u0432\\u0456\\u0434-10",
  "data-name": "\\u041A\\u043E\\u0432\\u0456\\u0434",
  transform: "translate(35.432 30.164)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_1",
  "data-name": 1,
  className: "cls-1",
  d: "M280.393,240.165a1.273,1.273,0,1,1,.9-.373A1.282,1.282,0,0,1,280.393,240.165Z",
  transform: "translate(-279.12 -237.62)"
})));

var SvgCovid = function SvgCovid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041A\\u043E\\u0432\\u0456\\u0434",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/covid.2c81dd08.svg";
export { ForwardRef as ReactComponent };